<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.name" placeholder="Search" @change="filterUsers"></el-input>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="users" highlight-current-row v-loading="listLoading" style="width: 100%">
            <el-table-column prop="email" label="User Email" :min-width="25" sortable></el-table-column>
            <el-table-column prop="role" label="Role" sortable :min-width="25"></el-table-column>
            <el-table-column prop="zone_name" label="Active Zone" sortable :min-width="25"></el-table-column>
            <el-table-column align="right" :min-width="25">
                <template scope="scope">
                    <div style="display: inline-block">
                        <el-button type="info" size="small"
                            @click="userZonesClick(scope.$index, scope.row)">Zones</el-button>
                        <el-button type="info" size="small"
                            @click="userDeleteClick(scope.$index, scope.row)">Delete</el-button>
                        <!--<el-button type="danger" size="small" @click="zoneDeleteClick(scope.$index, scope.row)">Delete</el-button>-->
                    </div>
                </template>
            </el-table-column>
        </el-table>


        <!--Zone management -->
        <el-dialog :title="userDeleteDialog.title" :visible.sync="userDeleteDialog.visible">
            <el-form :model="userDeleteDialog.form" v-loading="userDeleteDialog.loading" @submit.native.prevent>
                <el-form-item label="User Email">
                    <el-input v-model="userDeleteDialog.form.email" type="text" readonly></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 10px">
                    <el-button type="primary" style="margin-top: 10px"
                        @click="userDeleteDialog.visible = false">Cancel</el-button>
                    <el-button type="primary" style="margin-top: 10px" @click="userDeleteDialogClick()">Delete</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="userZonesDialog.title" :visible.sync="userZonesDialog.visible">
            <el-form :model="userZonesDialog.form" v-loading="userZonesDialog.loading" @submit.native.prevent>
                <el-form-item label="User Email">
                    <el-input v-model="userZonesDialog.form.email" type="text" readonly></el-input>
                </el-form-item>
                <el-tag style="margin-right: 10px;margin-bottom: 5px;" v-for="zone in userZonesDialog.form.zones" closable
                    @close="handleRemoveAccessZone(zone.id)">
                    {{ zone.name }}
                </el-tag>
                <el-form-item style="margin-top: 10px">
                    <el-button type="primary" style="margin-top: 10px"
                        @click="userZonesDialog.visible = false">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </section>
</template>
  
<script>
import Axios from "axios"
import UserService from "@/api/user.service"

export default {
    data() {
        return {
            filters: {
                name: ""
            },
            allUsers: [],
            users: [],
            listLoading: false,
            user: this.$session.get("User"),
            userDeleteDialog: {
                title: "Delete User",
                visible: false,
                loading: false,
                form: {
                    email: "",
                }
            },
            userZonesDialog: {
                title: "Zones Accesible to User",
                visible: false,
                loading: false,
                form: {
                    email: "",
                    zones: []
                }
            }
        }
    },
    methods: {
        handleRemoveAccessZone(zoneId) {
            console.log(zoneId);
            UserService.deleteUserAccessToZone(this.userZonesDialog.form.email, zoneId).then(result => {
                console.log(result)
                if (result.data.result != null && result.data.result == "success") {
                    Axios.all([UserService.getUserZoneAccess(this.userZonesDialog.form.email)]).then(
                        Axios.spread((userZoneAccessResponse) => {
                            this.userZonesDialog.form.zones = userZoneAccessResponse.data
                        }))
                } else {
                    this.$notify({
                        title: "User Zone Access",
                        message: result.data.error,
                        type: "error"
                    })
                }
            })
        },
        userDeleteClick(index, row) {
            this.userDeleteDialog.form.email = row.email
            this.userDeleteDialog.visible = true
        },
        userDeleteDialogClick() {
            //Delete the user
            UserService.deleteUser(this.userDeleteDialog.form.email).then(result => {
                if (result.data.result != null && result.data.result == "success") {
                    this.$notify({
                        title: "User Delete",
                        message: "User Deleted",
                        type: "info"
                    })
                    this.getUsers()
                    this.userDeleteDialog.visible = false
                } else {
                    this.$notify({
                        title: "User Delete",
                        message: result.data.error,
                        type: "error"
                    })
                    this.userDeleteDialog.visible = false
                }
            })
        },
        userZonesClick(index, row) {
            Axios.all([UserService.getUserZoneAccess(row.email)]).then(
                Axios.spread((userZoneAccessResponse) => {
                    this.userZonesDialog.form.zones = userZoneAccessResponse.data
                }))
            this.userZonesDialog.form.email = row.email
            this.userZonesDialog.visible = true
        },

        zoneEditClick(index, row) {
            this.zoneDialog.title = "Edit Zone"
            this.zoneDialog.form.name = row.name
            this.zoneDialog.form.deviceID = row.id
            this.zoneDialog.form.zoneID = row.gsd_id
            this.zoneDialog.form.boro = row.boro_id
            this.zoneDialog.visible = true
            this.zoneDialog.showPanelID = false
        },
        zoneDeleteClick(index, row) {
            this.$confirm("This will permanently delete the Zone. Continue?", "Warning", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "warning"
            })
                .then(() => {
                    Axios.all([UserService.deleteZone(row.id)]).then(
                        Axios.spread((deleteZoneResponse) => {
                            if (deleteZoneResponse.data.result == "success") {
                                this.getZones()
                                this.$message({
                                    type: "success",
                                    message: "Delete completed"
                                })
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "Error Deleting Zone"
                                })
                            }
                        })
                    )
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "Delete canceled"
                    })
                })
        },
        handleCurrentChange() { },
        filterUsers() {
            if (this.filters.name.length > 0) {
                this.users = this.allUsers.filter((user) => user.email.toLowerCase().includes(this.filters.name.toLowerCase()))
            } else {
                this.users = this.allUsers
            }
        },
        getUsers() {
            this.listLoading = true
            Axios.all([UserService.getUsers()]).then(
                Axios.spread((usersResponse) => {
                    this.listLoading = false
                    this.allUsers = usersResponse.data
                    this.users = usersResponse.data
                    //this.zones = zonesResponse.data
                    this.filterUsers()
                })
            )
            Axios.all([UserService.getBoros()]).then(
                Axios.spread((getBorosResponse) => {
                    this.boro_options = getBorosResponse.data
                })
            )
        },
    },
    mounted() {
        this.getUsers()
    }
}
</script>
  
<style scoped></style>
  


// WEBPACK FOOTER //
// Users.vue?7d68bbb6